import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Chọn thành viên", -1)
const _hoisted_6 = { class: "flex align-items-center" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { style: {"width":"20px"} }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1)
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-12 p-lg-6" }
const _hoisted_12 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_13 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_14 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_15 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col-5 p-md-5" }
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Panel, { header: "Thêm nhân viên hỗ trợ đặt lịch" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Dropdown, {
                modelValue: $setup.receiverStatistical.idZalo,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.receiverStatistical.idZalo) = $event)),
                options: $setup.listCustomer,
                optionLabel: "name",
                optionValue: "id",
                placeholder: "Chọn tài khoản",
                filter: true,
                style: {"height":"35px"}
              }, {
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_6, [
                    (slotProps.option.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: slotProps.option.imageUrl,
                          style: {"width":"20px","margin-right":"3px"}
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_8, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Button, {
                label: "Thêm",
                icon: "pi pi-plus-circle",
                iconPos: "left",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addMember())),
                disabled: !$setup.receiverStatistical.idZalo
              }, null, 8, ["disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_Panel, { header: "Danh sách nhân viên hỗ trợ đặt lịch" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_DataTable, {
                loading: _ctx.isLoading,
                value: $setup.listReceiverStatistical,
                paginator: true,
                stripedRows: "",
                rows: 10,
                rowsPerPageOptions: [10,25,50],
                rowHover: true,
                filters: $setup.filters,
                "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => (($setup.filters) = $event)),
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                globalFilterFields: ['zaloName'],
                currentPageReportTemplate: "Có tổng số {totalRecords} thành viên",
                columnResizeMode: "fit | expand"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm theo tên hoặc số điện thoại"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "imageLink",
                    header: "Ảnh đại diện",
                    sortable: ""
                  }, {
                    body: _withCtx((slotProps) => [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("img", {
                            src: slotProps.data.imageLink,
                            style: {"width":"60px"}
                          }, null, 8, _hoisted_19)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "zaloName",
                    header: "Họ và tên",
                    sortable: ""
                  }),
                  _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        class: "p-button-danger",
                        label: "Xoá",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.deleteManager(slotProps.data.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "value", "filters"])
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}